export enum ClaimBenefitDecisionEnum {
    OPEN = 'Open',
    APPROVED = 'Approved',
    DENIED = 'Denied',
    ADMINCLOSED = 'AdminClosed'
}
